export default "__VITE_ASSET__CfzWoGwy__"